import React from 'react';
import {observer} from 'mobx-react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {StandingsWidgetTableContent} from "./standings-widget.table-content";
import {StandingsWidgetController} from "../../standings-widget.controller";
import {StandingsWidgetTableStandingsGroups} from "./standings-widget.table.standings-groups";
import classNames from "classnames";
import styles from '../../../../core/components/scrollable-table/scrollable-table.module.scss';

export class StandingsWidgetTableProps extends BaseProps {
  controller: StandingsWidgetController;
  isPreviewStandings: Boolean;
  source: String;
}

export const StandingsWidgetTable = observer(({controller, isPreviewStandings, source}: StandingsWidgetTableProps) => {
  const {state} = controller;
  const {standingsRows, hasGroups, headers, isSmallView} = state;

  const baseProps = {
    controller,
    isPreviewStandings,
    source
  }

  const standingsProps = {
    rows: standingsRows,
    shouldRenderTable: !hasGroups,
    headers,
    ...baseProps,
  }

  return (
    <div className={classNames({[styles.table]: !hasGroups},{[styles.small_view]: isSmallView})} id={'table-container'}>
      {
        hasGroups ? <StandingsWidgetTableStandingsGroups {...baseProps}/> :
          <StandingsWidgetTableContent {...standingsProps}/>
      }
    </div>
  )
});
